import { render, staticRenderFns } from "./RevokeModal.vue?vue&type=template&id=1f15f2e2"
import script from "./RevokeModal.vue?vue&type=script&lang=js"
export * from "./RevokeModal.vue?vue&type=script&lang=js"
import style0 from "./RevokeModal.vue?vue&type=style&index=0&id=1f15f2e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports